import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import { TextField } from '@material-ui/core';

const styles = () => ({
  dialogContent: {
    height: 250,
  },
  dialogBorder: {
    height: '20px',
  },
  title: {
    marginBottom: '.5em',
  },
  textField: {
    '& label.Mui-focused': {
      color: 'grey',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'grey',
      },
    },
  },
});

// Modal for maintainers to see requests
const MakeTermRequestModal = (props) => {
  const { open, handleClose, defaultParent, requestTerm, classes } = props;
  let term = '';
  let details = '';
  let parentTerm = defaultParent ? defaultParent : '';
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <div className={classes.dialogBorder} />
        <DialogTitle>
          <Typography variant="h4" className={classes.textCaps}>
            Request A Term
          </Typography>
        </DialogTitle>
        <div className={classes.dialogBody}>
          <DialogContent className={classes.dialogContent}>
            <div style={{ marginBottom: '2em' }}>
              <TextField
                fullWidth
                className={classes.textField}
                variant="outlined"
                label="Requested Term"
                onChange={(val) => (term = val.target.value)}
              />
            </div>
            <div style={{ marginBottom: '2em' }}>
              <TextField
                fullWidth
                className={classes.textField}
                variant="outlined"
                label="Additional Info"
                onChange={(val) => (details = val.target.value)}
              />
            </div>
            <div>
              <TextField
                fullWidth
                className={classes.textField}
                variant="outlined"
                defaultValue={defaultParent}
                label="Parent Term"
                onChange={(val) => (parentTerm = val.target.value)}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                if (term !== '') {
                  requestTerm(term, parentTerm, details);
                }
              }}
              variant="outlined"
            >
              Submit Request
            </Button>
            <Button onClick={handleClose} variant="outlined">
              Close
            </Button>
          </DialogActions>
        </div>
        <div className={classes.dialogBorder} />
      </Dialog>
    </div>
  );
};

// Modal for maintainers to see requests
export default withStyles(styles)(MakeTermRequestModal);
